var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"shrink tw-cursor-pointer",attrs:{"alt":_vm.alt,"contain":"","src":_vm.src,"transition":"fade-transition","width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }